exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-splash-screen {\n  background: #fff;\n  position: fixed;\n  display: block;\n  z-index: 99999999;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 1;\n  transition: opacity .3s;\n}\n.app-splash-screen-content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  animation: appSplashScreenAnimation 1.2s ease-in-out 0s infinite;\n}\n@keyframes appSplashScreenAnimation {\n0%,\n  20% {\n    transform: translate(-50%, -50%) rotateY(0);\n}\n50% {\n    transform: translate(-50%, -50%) rotateY(180deg);\n}\n80%,\n  100% {\n    transform: translate(-50%, -50%) rotateY(360deg);\n}\n}\n", ""]);

// exports
